import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import {
    domainName
} from "../../../utility/index"
import {
    downLoadCarTemplateFile,
    exportCarXLXS
} from '../../../api/config/modules/VehicleFiles'
import moment from "moment";
export default {
    components: {
        tree,
        iTable,
        IPagination
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                insuranceState: '',
                insureStartTime: '',
                insureEndTime: '',
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.plateNum')
            }, {
                value: '3',
                label: this.$t('common.customNum')
            },
            {
                value: '4',
                label: this.$t('common.manufactureNum')
            }],
            StateList: [
                {
                    value: null,
                    label: this.$t('common.all')
                },
                {
                    value: '0',
                    label: this.$t('common.normal')
                },
                {
                    value: '1',
                    label: this.$t('common.nearTime')
                },
                {
                    value: '2',
                    label: this.$t('common.exceedTime')
                }
            ],
            height: '550',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [{
                prop: "carId",
                label: this.$t('common.carId'),
                align: "center",
                width: "120px",
            },
            {
                prop: "manufactureNum",
                label: this.$t('common.manufactureNum'),
                align: "center",
                width: "150px"
            },
            {
                prop: "customNum",
                label: this.$t('common.customNum'),
                align: "center",
                width: "120px"
            },
            {
                prop: "plateNum",
                label: this.$t('common.plateNum'),
                align: "center",
                width: "120px"
            },
            {
                prop: "orgName",
                label: this.$t('common.orgName'),
                align: "center",
            },
            {
                prop: "insuranceStateStr",
                label: this.$t('GovernmentRegulation.insureType'),
                align: "center",
                render: (h, params) => {
                    return h('el-tag', {
                        props: { type: params.row.insuranceState === null ? '' : params.row.insuranceState === 0 ? 'success' : params.row.insuranceState === 1 ? 'warning' : 'danger' }
                    }, params.row.insuranceState === null ? '' : params.row.insuranceState === 0 ? this.$t('common.normal') : params.row.insuranceState === 1 ? this.$t('common.nearTime') : this.$t('common.exceedTime'))
                }
            },
            {
                prop: "insureStartTime",
                label: this.$t('VehicleManagement.insureStartTime'),
                align: "center",
                width: "200px"
            },
            {
                prop: "insureEndTime",
                label: this.$t('VehicleManagement.insureEndTime'),
                align: "center",
                width: "200px"
            },
            {
                prop: "isInsureFilePath",
                label: this.$t('VehicleManagement.isInsureFilePath'),
                align: "center",
                render: (h, params) => {
                    if (params.row.isInsureFilePath == 1) {
                        return h('el-button',
                            {
                                props: {
                                    type: 'text', size: 'small', icon: 'iconfont iconxiazai-copy'
                                },
                                on: {
                                    click: () => {
                                        this.downFile(params.row)
                                    }
                                }
                            }, '')
                    } else {
                        return h('el-button',
                            {
                                props: {
                                    type: 'text', size: 'small', icon: 'iconfont iconxiazai', disabled: true
                                },
                            }, '')
                    }
                }
            },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1, 
            pageSize: 10, 
            total: 1, 
            dialogFormVisible: false,
            formLabelWidth: '130px',
            diaTitle: '',
            btnType: '',
            rules: {},
            form: {
                carId: '',
                insureStartTime: '',
                insureEndTime: '',
                insureFilePath: ''
            },
            selected: [],
            id: '',
            name: '',
            dialogBatchFormVisible: false,
        }
    },
    created() {
        
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.getAllCar()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getAllCar()
        },
        getAllCar() {
            let insureStartStartTime = ''
            let insureStartEndTime = ''
            if (this.formInline.insureStartTime) {
                if (this.formInline.insureStartTime.length > 0) {
                    insureStartStartTime = this.formInline.insureStartTime[0]
                    insureStartEndTime = this.formInline.insureStartTime[1]
                }
            }
            let insureEndStartTime = ''
            let insureEndEndTime = ''
            if (this.formInline.insureEndTime) {
                if (this.formInline.insureEndTime.length > 0) {
                    insureEndStartTime = this.formInline.insureEndTime[0]
                    insureEndEndTime = this.formInline.insureEndTime[1]
                }
            }
            let param = {
                companyId: sessionStorage.getItem("companyId"),
                orgId: this.id,
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                insuranceState: this.formInline.insuranceState,
                insureStartStartTime: insureStartStartTime,
                insureStartEndTime: insureStartEndTime,
                insureEndStartTime: insureEndStartTime,
                insureEndEndTime: insureEndEndTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('InsureFile/GET_SELECTCARINSURANCE', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getAllCar()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                insuranceState: '',
                insureStartTime: '',
                insureEndTime: '',
            }
            this.getAllCar()
        },
        editCar() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.edit')
            this.btnType = 'edit'
            this.$nextTick(() => {
                console.log(this.selected[0])
                this.form.carId = this.selected[0].carId
                this.form.insureStartTime = this.selected[0].insureStartTime
                this.form.insureEndTime = this.selected[0].insureEndTime
                this.form.insureFilePath = this.selected[0].insureFilePath
                this.$refs.form.clearValidate()
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        carId: this.form.carId,
                        insureStartTime: this.form.insureStartTime,
                        insureEndTime: this.form.insureEndTime,
                        insureFilePath: this.form.insureFilePath,
                    }
                    if (this.btnType == 'edit') {
                        this.$store.dispatch('InsureFile/GET_UPDATECARINSURANCE', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.editSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllCar();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else {

                    }


                } else {
                    return false;
                }
            });
        },
        uploadFiles(e) {
            let dom = document.getElementById('uploadFile')
            let file = dom.files[0];
            let formData = new FormData()
            formData.append('file', file)
            formData.append('path', 'carFilePath')
            this.$store.dispatch('FileController/GET_UPLOADCONTRACTFILE', formData).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(this.$t('common.btn.fileUploadSuccess'))
                    this.form.insureFilePath = res.data.data[0]
                } else {
                    this.$message.error(res.data.msg)
                }
            }).catch(err => {
                this.$message.error(this.$t('common.btn.fileUploadError'))
                document.getElementById('uploadDom').value = ''
            })
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                carId: '',
                insureStartTime: '',
                insureEndTime: '',
                insureFilePath: ''
            }
        },
        closeDia() {
            this.form = {
                carId: '',
                insureStartTime: '',
                insureEndTime: '',
                insureFilePath: ''
            }
            this.dialogFormVisible = false;
        },
        downFile(row) {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/FileController/getFile?filePath=${row.insureFilePath}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/FileController/getFile?filePath=${row.insureFilePath}`
                    location.href = url
                }
            }
        },

        BulkImport() {
            this.dialogBatchFormVisible = true
        },
        
        TemplateFile() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportCarInsuranceTemplate`
                    location.href = url
                    
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportCarInsuranceTemplate`
                    location.href = url
                    
                }
            }
        },
        
        uploadCar(e) {
            let dom = document.getElementById('uploadDom')
            let file = dom.files[0];
            let formData = new FormData()
            formData.append('File', file)
            let types = file.name.split('.')[1]
            if (types != "xlsx" && types != "xls") {
                this.$message.error(this.$t('common.btn.choseExcelFile'));
                return false;
            } else {
                this.$store.dispatch('InsureFile/GET_UPLOADCARINSURANCE', formData).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(this.$t('common.btn.fileUploadSuccess'))
                        this.dialogBatchFormVisible = false;
                        this.getAllCar()
                    } else {
                        this.$message.error(res.data.msg)
                    }
                    document.getElementById('uploadDom').value = ''
                }).catch(err => {
                    this.$message.error(this.$t('common.btn.fileUploadError'))
                    document.getElementById('uploadDom').value = ''
                })
            }
        },
        closeBatchDia() {
            this.dialogBatchFormVisible = false
        },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let insureStartStartTime = ''
                    let insureStartEndTime = ''
                    if (this.formInline.insureStartTime) {
                        if (this.formInline.insureStartTime.length > 0) {
                            insureStartStartTime = this.formInline.insureStartTime[0]
                            insureStartEndTime = this.formInline.insureStartTime[1]
                        }
                    }
                    let insureEndStartTime = ''
                    let insureEndEndTime = ''
                    if (this.formInline.insureEndTime) {
                        if (this.formInline.insureEndTime.length > 0) {
                            insureEndStartTime = this.formInline.insureEndTime[0]
                            insureEndEndTime = this.formInline.insureEndTime[1]
                        }
                    }
                    let companyId = sessionStorage.getItem("companyId")
                    let url = `https://${domainName}/v1/getExportExcel/exportCarInsurance?orgId=${this.id}&companyId=${companyId}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&insuranceState=${this.formInline.insuranceState}&insureStartStartTime=${insureStartStartTime}&insureStartEndTime=${insureStartEndTime}&insureEndStartTime=${insureEndStartTime}&insureEndEndTime=${insureEndEndTime}`
                    location.href = url

                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportCarInsurance?orgId=${this.id}&companyId=${companyId}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&insuranceState=${this.formInline.insuranceState}&insureStartStartTime=${insureStartStartTime}&insureStartEndTime=${insureStartEndTime}&insureEndStartTime=${insureEndStartTime}&insureEndEndTime=${insureEndEndTime}`
                    location.href = url
                }
            }
        },

        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getAllCar();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}